import { Link } from "react-router-dom";

import { RenderWhen } from "../../../../../../components";
import RLCard from "../../../../../../components/card/RLCard";
import { route } from "../../../../../../shim/jsbridge";
import { COMPONENT_IDS } from "../../../../consts";
import commonStyles from "../../../../containers/report_summary/report-summary.module.scss";
import {
  useLocalSampleDetails,
  useLocalSampleSummaryParams
} from "../../../../hooks";
import { pathToExtractedFile } from "../../../../util";
import { DESCRIPTIONS } from "../../../layout-editor/consts";
import { useEmailAttachments } from "../../hooks";
import { Tooltip } from "../common";
import LeftEmailColumn from "./LeftEmailColumn";
import RightEmailColumn from "./RightEmailColumn";

const EmailCard = () => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();
  const { data: localData } = useLocalSampleDetails(
    hash,
    sourceId,
    relationshipId
  );
  const metadataRoute = route(
    "samples_details_section",
    {
      source_id: sourceId,
      hash_value: hash,
      section: "ticore/email/message"
    },
    { r: relationshipId }
  );

  const sourceHash = localData?.sample_source_sha1;
  const { attachmentsPath } = useEmailAttachments(
    sourceHash || hash || "",
    relationshipId ?? 0
  );

  const allAttachmentsRoute = pathToExtractedFile(
    hash,
    sourceId,
    attachmentsPath,
    relationshipId
  );

  return (
    <RLCard
      header={
        <RLCard.LinkHeader
          title={
            <Tooltip
              placement="top"
              message={DESCRIPTIONS[COMPONENT_IDS.EMAIL]}
            >
              <span>Email Information</span>
            </Tooltip>
          }
          LinkComponent={
            <div className={"flex flex-gap-3"}>
              <Link
                to={metadataRoute}
                className={commonStyles.link}
                data-testid="email_card_see_metadata_link"
              >
                See All Metadata
              </Link>
              <RenderWhen condition={!!attachmentsPath}>
                <div className={commonStyles.header_divider} />
                <Link
                  to={allAttachmentsRoute}
                  className={commonStyles.link}
                  data-testid="email_card_see_attachments_link"
                >
                  See All Attachments
                </Link>
              </RenderWhen>
            </div>
          }
        />
      }
      content={
        <RLCard.Content>
          <section className="flex flex-gap-12">
            <LeftEmailColumn metadataRoute={metadataRoute} />
            <RightEmailColumn
              hashValue={hash || ""}
              sourceID={sourceId}
              relationshipID={relationshipId}
              attachmentsRoute={allAttachmentsRoute}
            />
          </section>
        </RLCard.Content>
      }
      data-testid="report_summary_email_card"
    />
  );
};

export default EmailCard;
